import { css } from '@emotion/core';

type SupportedUnits = '%' | 'ms';

const comparisonStyles = (symbol: '<' | '>', units: SupportedUnits) => css`
position: relative;
  padding-left: 1.5em;

  &::before {
    content: '${symbol}';
    display: block;
    position: absolute;
    left: 0.75em;
  }

  &::after {
    content: '${units}';
    display: block;
    position: absolute;
    right: 1.85em;
  }
`;

export const lessThanUnitStyles = (units: SupportedUnits = '%') => comparisonStyles('<', units);

export const greaterThanUnitStyles = (units: SupportedUnits = '%') => comparisonStyles('>', units);
